import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import role from 'role';

export default function NationalTermList({ match, rootTermId, t }) {
    const fields = [
        { name: t('Term'), key: 'term' },
        { name: t('Country'), keys: ['country', 'name'] },
        { name: t('Record User'), keys: ['recordUser', 'email'] },
        { name: t('Record Timestamp'), key: 'recordTimestamp' }
    ];

    return (
        <ListCRUD
            plural='nationalTerms'
            singular='nationalTerm'
            fields={fields}
            match={match}
            canEdit={[role.ADMIN, role.NATIONAL_AUTHORITY]}
            canNew={[role.ADMIN, role.NATIONAL_AUTHORITY]}
            extraQueryParams={{rootTermId: rootTermId}}
            disableViewButton
        />
    );
}